import styled from 'styled-components';
import { tokens } from '@snsw-gel/react';
import { vars } from '@snsw-gel/theming';
import { pxToRem, getSpacing } from '@snsw-gel/utils';

export const StyledSearchContainer = styled.div`
  position: relative;
  max-width: 100%;

  /* Make the search input fill the full width (design system caps it otherwise). */
  input {
    max-width: 100%;
    width: 100%;
  }
`;

export const StyledDropdown = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
  width: 100%;
  max-height: ${pxToRem(358)};
  overflow: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: ${vars.colors.forms.bg};
  border: 2px solid ${vars.colors.forms.border};
  border-top: none;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 2px 18px 0 rgba(0, 0, 0, 0.05);
`;

export const StyledDropdownItem = styled.li`
  display: flex;
  align-items: center;
  min-height: ${pxToRem(24)};
  padding: ${getSpacing(['13', 'sm', '13', 'sm'])};
  margin: 0;
  border-top: 1px solid ${vars.colors.bg.border};
  cursor: pointer;

  &:first-child {
    border-top: none;
  }

  &:hover,
  &:focus {
    background: ${vars.colors.accent3.default};
    color: ${vars.colors.accent3.text};
    outline: none;
  }
`;

export const StyledAddNewLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-top: 0.5rem;
  color: ${tokens.colors.brand.snswSecondaryBlue};
  text-decoration: underline;
  font-size: 1rem;
  cursor: pointer;
  display: inline-block;

  &:hover {
    color: ${tokens.colors.brand.snswPrimaryBlue};
  }
`;

// Groups the secondary actions in the search view ("Enter business name
// manually" and, when the user has saved businesses, "Back to business
// selection") so they read as a consistent stack of link actions.
export const StyledLinkGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1rem;
`;
